import React from 'react'

//Material core
import {
  Grid,
  Container,
  Row,
  Button,
} from '@material-ui/core'

import './tutorial.css'

class IndexPage extends React.Component {
  state={
    step: 0
  }

  next(){
    this.setState({step: this.state.step + 1})
  }
  renderStep(){
    switch (this.state.step) {
      case 7:
        return (
          <div style={{textAlign: 'center'}}>
            <h1>Bem vindo!</h1>
            <div><lottie-player src={'/assets/webphone.json'}  background="transparent"  speed="1"  style={{width: '100%', height: '200px'}} hover loop autoplay></lottie-player></div>
            <Button onClick={() => this.next()}variant="contained" style={{backgroundColor:'#218838', color: 'white', marginTop: '2em'}}>Avançar</Button>
          </div>
        )
      
      case 0:
        return (
          <div style={{textAlign: 'center'}}> 
            <h1 className='title'>Bem vindo!</h1>
            <p className='texto'>Nunca foi tão fácil assinar um documento!</p>
            <div><lottie-player src={'/assets/sign.json'}  background="transparent"  speed="1"  style={{width: '100%', height: '200px'}} hover loop autoplay></lottie-player></div>
            <Button onClick={() => this.next()}variant="contained" style={{backgroundColor:'#218838', color: 'white', marginTop: '2em'}}>Avançar</Button>
          </div>
        )
      case 1:
        return (
          <div style={{textAlign: 'center'}}>
            <h2 className='subtitle'>Passo a passo</h2>
            <ul>
              <li >1 - Insira o código que recebeu por e-mail e suas informações</li>
              <li >2 - Leia o documento a assinar</li>
              <li >3 - Utilize o dedo indicador (smartphone) ou o mouse (computador) para assinar</li>
              <li >4 - Concluído</li>
            </ul>
            <Button onClick={() => this.next()}variant="contained" style={{backgroundColor:'#218838', color: 'white', marginTop: '2em'}}>Avançar</Button>
          </div>
        )
      case 2:
        return (
          <div style={{textAlign: 'center'}}> 
            <div><lottie-player src={'/assets/document.json'}  background="transparent"  speed="1"  style={{width: '100%', height: '200px'}} hover autoplay></lottie-player></div>
            <h2 className='subtitle'>Vamos assinar?</h2>
            <Button onClick={() => this.props.history.push('auth')}variant="contained" style={{backgroundColor:'#218838', color: 'white', marginTop: '2em'}}>Sim, vamos!</Button>
          </div>
        )
    }
  }
  render(){
    return(
      <div style={{height: '100%', justifyContent: 'center'}}>
        <Container style={{height: '100%'}}>
            <Grid 
              container
              direction="row"
              justify="center"
              alignItems="center"
                spacing={3} style={{height: '100%', width: '90%', margin: 'auto'}}>
              <Grid 
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
              <Grid item md={6}justify="center">
                <div style={{textAlign: 'center'}}>
                  <img src="/assets/imagem/logo-finsol.svg" alt=""  style={{width: '100%', maxWidth: '300px', margin: 'auto', tintColor: 'white'}}/>
                </div>
              </Grid>
              <Grid item md={6} justify="center" alignItems="center">
                {this.renderStep()}
              </Grid>
              </Grid>
            
            </Grid>
            <a href='#' style={{position: 'absolute', bottom: 20, left: 20, color: 'white'}}>RBM WEB</a>
      </Container>
      <style>
        {
          `#root{ background: linear-gradient(60deg, #083b7e 0, #825ee4 100%) !important;}`
        }
      </style>
      </div>
    )
  }
}

export default IndexPage